<template>
    <!-- Modal tabindex="-1" -->
    <div
      class="modal fade"
      id="exampleModal"
      
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
      ref="DetailsModalModal"
      >
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="min-width: 90%;">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ title }}</h5>
            <!-- <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button> -->
          </div>
          <div class="modal-body">
            <Search :user="user" :accessToken="accessToken" @close="SearchEmpleatSeleccionat" ref="searchForm"/>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              @click="this.hide"
            >
              Tancar
            </button>
            <button type="button" class="btn btn-primary" @click="SearchEmpleatSeleccionat">Seleccionar</button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { Modal } from "bootstrap"
  import Search from "@/components/assignaTags/CercaEmpleat.vue"
  export default {
    name: 'DetailsModal',
    components: { Search },
    data: function() {
        return {
          DetailsModalModal: null,
        }
    },
    props: {
      user: {
        type: Object,
        required: false,
      },
      accessToken: {
        type: String,
        required: true,
      },
      title: {
        type: String,
        required: true,
      },
      // wrap: {
      //   type: Boolean,
      //   default: false
      // }
    },
    mounted() {
        this.DetailsModalModal = new Modal(this.$refs.DetailsModalModal)
    },
    methods: {
      SearchEmpleatSeleccionat(empleat) {
        //console.log(empleat.displayName)
        this.$emit('close',empleat)
        this.hide()
      },
      show() {
          this.DetailsModalModal.show()
          this.$nextTick(() => {
            this.$refs.searchForm.inputFocus();
          })
          //this.visible=true
      },
      hide() {
          this.DetailsModalModal.hide()
          //this.visible=false
      }
    }
  }
  </script>
  
  <style scoped>
    /* .modal-content {
      width: 80% !important;
    }
  
    .wrap-pre {
      word-wrap: break-word;
      white-space: pre-wrap;
    } */
  </style>